var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 45,
    viewBox: "0 0 118 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.307 0.5C35.0365 0.5 31.5745 3.96196 31.5745 8.23251V21.12H48.3283C52.5988 21.12 56.0608 17.6581 56.0608 13.3875V0.5H39.307ZM50.9058 5.655L39.307 5.65501C37.8835 5.65501 36.7295 6.80899 36.7295 8.23251V15.965L48.3283 15.965C49.7518 15.965 50.9058 14.811 50.9058 13.3875L50.9058 5.655Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50977 8.23282C4.50977 3.96227 7.97174 0.500311 12.2423 0.500311H28.996V5.65532C28.996 7.63575 28.2515 9.4423 27.0271 10.8103C28.2515 12.1784 28.996 13.9849 28.996 15.9653V21.1203L4.50977 21.1203V8.23282ZM23.841 5.65532L12.2423 5.65532C10.8188 5.65532 9.66478 6.8093 9.66478 8.23282V15.9653H23.841C23.841 14.5427 22.6884 13.3892 21.2661 13.3878H12.2423V8.23282L21.2635 8.23282C22.6871 8.23282 23.841 7.07883 23.841 5.65532Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.636 8.23251C58.636 3.96196 62.0979 0.5 66.3685 0.5H83.1223V5.655L66.3685 5.65501C64.945 5.65501 63.791 6.80899 63.791 8.23251V15.965L83.1223 15.965V21.12H58.636V8.23251Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4312 21.12L90.1325 5.57063C91.2492 2.52488 94.1483 0.5 97.3923 0.5H100.501C103.745 0.5 106.645 2.52481 107.761 5.57048L113.463 21.12H107.972L106.082 15.9651H91.8585V15.8377L89.9218 21.12H84.4312ZM104.192 10.8101L102.921 7.34517C102.549 6.32994 101.583 5.65501 100.501 5.65501L97.3923 5.65501C96.311 5.65501 95.3446 6.32997 94.9724 7.34522L93.702 10.8101H104.192Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8581 28.7675L88.1568 44.3169H93.6474L95.5842 39.0346V39.1619H109.808L111.698 44.3169H117.189L111.487 28.7674C110.37 25.7217 107.471 23.6969 104.227 23.6969H101.118C97.8739 23.6969 94.9748 25.7218 93.8581 28.7675ZM106.647 30.5421L107.918 34.0069H97.4276L98.698 30.5421C99.0702 29.5269 100.037 28.8519 101.118 28.8519L104.227 28.8519C105.308 28.8519 106.275 29.5268 106.647 30.5421Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5734 44.3169V23.6969H32.7284V31.4294H46.9047V23.6969H52.0597V44.3169H46.9047V36.5844H32.7284V44.3169H27.5734Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7907 44.3168V23.6968H54.6357V44.3168H59.7907Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24227 23.6972C3.97173 23.6972 0.509766 27.1591 0.509766 31.4297V44.3172H24.996V39.1622L5.66477 39.1622V31.4297C5.66477 30.0062 6.81876 28.8522 8.24227 28.8522H24.996V23.6972H8.24227Z",
    fill: "#0B0B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3699 31.4294C62.3699 27.1589 65.8319 23.6969 70.1024 23.6969H86.8562V28.8519H70.1024C68.6789 28.8519 67.5249 30.0059 67.5249 31.4294V39.1619L86.8562 39.1619V44.3169H62.3699V31.4294Z",
    fill: "#0B0B17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBc);
export default __webpack_public_path__ + "static/media/bc.7f8d7ab45b820d7aca9274d5e51ac454.svg";
export { ForwardRef as ReactComponent };